import moment from "moment";

export function transformMiniTransactions(transactions, groupedTransactions) {

  if (!Array.isArray(transactions)) return groupedTransactions;

  let resultSwitchOut = [];
  let resultSwitchIn = [];
  let outSuccessInFail = [];

  resultSwitchOut = transactions.filter(
    item => !(item.type === "SwitchOut" && item.status === "9")
  );

  resultSwitchIn = resultSwitchOut.filter(
    item => !(item.type === "SwitchIn" && item.status === "9")
  );

  outSuccessInFail = resultSwitchIn.filter(item => {
    if (item.type === "SwitchOut") {
      const hasSwitchInDetailWithStatus9 =
        item.details &&
        item.details.some(detail => {
          return detail.type === "SwitchIn" && detail.status === "9";
        });

      return !hasSwitchInDetailWithStatus9;
    }

    return true;
  });


  for (const res of outSuccessInFail) {
    const month = moment(res.submittedDate).format("MMMM");
    const year = new Date(res.submittedDate).getFullYear();
    const id = groupedTransactions.length + 1;

    if (
      ((res.type === "Buy" ||
        res.type === "ManBuy" ||
        res.type === "SwitchIn" ||
        res.type === "SwitchOut" ||
        res.type === "SwitchAll") &&
        res.status !== "5") ||
      ((res.type === "Sell" || res.type === "FullSell") && res.status !== "10")
    ) {
      continue;
    }

    const found = groupedTransactions.some(
      value => value.month === month && value.year === year
    );
    if (found) {
      const index = groupedTransactions.findIndex(
        value => value.month === month && value.year === year
      );
      groupedTransactions[index].data = [...groupedTransactions[index].data, res];
    } else {
      groupedTransactions.push({
        id: id,
        month: month,
        year: year,
        data: [res],
      });
    }
  }

  return groupedTransactions;
}
